import {
  env,
  envContext,
  getEnvDebugInfo,
  isClient,
  isClientRuntime,
  isDevOrStaging,
  isProduction,
  isServer,
  setupGlobalEnv
} from "./chunk-C3CDJ2AU.js";
export {
  env,
  envContext,
  getEnvDebugInfo,
  isClient,
  isClientRuntime,
  isDevOrStaging,
  isProduction,
  isServer,
  setupGlobalEnv
};
